import styled from "styled-components";

const FAQStyleWrapper = styled.section`
  position: relative;
  padding-bottom: 110px;
  background-color: #0d102d;
  padding-top: 110px;

  .left_image {
    color: #fff;
    margin-top: 50px;
  }

  .faq_content {
    width: 100%;
    margin: auto;
    position: relative;
    margin-top: 70px;
  }

  .main_faq_questions {
    position: relative;

    .faq_questions {
      position: relative;
      z-index: 1;

      .accordion__item + .accordion__item {
        margin-top: 10px;
      }
      
      .accordion__item{
        border-radius: 10px;
        border: 1px solid #FF06B7;
      }
    }
  }
  .accordion__item {
    background: #131740;
  }
  .accordion__header {
    h5 {
      display: flex;
      align-items: center;
      height: 76px;
      margin-bottom: 0px;
      padding: 0 29px;
      color: rgba(255, 255, 255);
      font-size: 22px;
      line-height: 34px;
      text-transform: none;
    }
  }

  .accordion__body {
    p {
      padding: 24px 48px 24px 29px;
      font-family: "Poppins";
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 28px;
      color: rgba(255, 255, 255);
      margin-bottom: 0px;
      max-width: 100%;
      border-top: 2px dashed #FF06B7;
    }
  }

  .faq_bg_wattermark {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 0;
  }

  @media only screen and (max-width: 992px) {
    .accordion__header {
      h5 {
        font-size: 20px;
        line-height: 28px;
      }
    }
  }

  @media only screen and (max-width: 667px) {
    padding-top: 50px;
    padding-bottom: 50px;
    .section_title {
      width: 70%;
    }
    .left_image {
      margin: 30px 0 57px 0;
    }

    .faq_content {
      margin-top: 0;
    }
  }

  @media only screen and (max-width: 500px) {
    .faq_content {
      margin-top: 0;
    }
  
    .accordion__header {
      h5 {
        font-size: 18px;
        line-height: 25px;
      }
    }

    .accordion__body {
      p {
        font-size: 14px;
        line-height: 25px;
      }
    }
  }

  @media only screen and (max-width: 375px) {
    .accordion__header {
      h5 {
        font-size: 15px;
      }
    }

    .accordion__body {
      p {
        font-size: 12px;
      }
    }
  }
`;

export default FAQStyleWrapper;
